import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Image } from 'shared/lib/SureDesignSystem';
import { isWebPSupported } from 'shared/lib/utils';
import LazyLoad from 'react-lazyload';

import styles from './Reviews.module.css';

const propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      review: PropTypes.string,
      author: PropTypes.string,
      location: PropTypes.string,
    })
  ).isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  className: null,
};

class Reviews extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      activeReviewIndex: 0,
      activeReview: props.items[0],
      previousReview: null,
      changeTransition: false,
    };
  }

  componentDidMount() {
    this.activeReviewIntervalId = setInterval(() => {
      this.setState(({ activeReviewIndex, activeReview }) => {
        const { items } = this.props;
        let newActiveReviewIndex = activeReviewIndex + 1;

        if (newActiveReviewIndex >= items.length) {
          newActiveReviewIndex = 0;
        }

        return {
          activeReviewIndex: newActiveReviewIndex,
          activeReview: items[newActiveReviewIndex],
          previousReview: activeReview,
          changeTransition: true,
        };
      });
    }, 10 * 1000);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.changeTransition && !prevState.changeTransition) {
      this.changeTransitionTimeoutId = setTimeout(() => {
        this.setState({
          changeTransition: false,
        });
      }, 1000);
    }
  }

  componentWillUnmount() {
    if (this.activeReviewIntervalId) {
      clearInterval(this.activeReviewIntervalId);
    }

    if (this.changeTransitionTimeoutId) {
      clearTimeout(this.changeTransitionTimeoutId);
    }
  }

  render() {
    const { activeReview, previousReview, changeTransition } = this.state;
    const { className } = this.props;

    const reviewToShow = changeTransition ? previousReview : activeReview;

    return (
      <div
        className={classnames(
          classnames(
            styles.wrapper,
            isWebPSupported
              ? styles.wrapperBackgroundWebp
              : styles.wrapperBackground
          ),
          {
            [styles.changeTransition]: changeTransition,
          },
          className
        )}
      >
        <div className={styles.container}>
          <div className={styles.reviewWrapper}>
            <div className={styles.review}>
              <div className={styles.reviewInner}>
                <div className={styles.reviewStars}>
                  <i className={classnames('fas fa-star', styles.reviewStar)} />
                  <i className={classnames('fas fa-star', styles.reviewStar)} />
                  <i className={classnames('fas fa-star', styles.reviewStar)} />
                  <i className={classnames('fas fa-star', styles.reviewStar)} />
                  <i className={classnames('fas fa-star', styles.reviewStar)} />
                </div>
                <p className={styles.reviewContent}>"{reviewToShow.review}"</p>
              </div>
            </div>
            <div className={styles.reviewShadow1} />
            <div className={styles.reviewShadow2} />
          </div>
          <div className={styles.reviewAuthorWrapper}>
            <div className={styles.reviewAvatarContainer}>
              <LazyLoad height={114} once>
                <Image
                  className={styles.reviewAvatar}
                  src={reviewToShow.avatar}
                  webp={reviewToShow.avatarWebp}
                  alt={`${reviewToShow.author}'s avatar`}
                />
              </LazyLoad>
            </div>
            <p className={styles.reviewAuthor}>{reviewToShow.author}</p>
            <p className={styles.reviewLocation}>{reviewToShow.location}</p>
          </div>
        </div>
      </div>
    );
  }
}

Reviews.propTypes = propTypes;
Reviews.defaultProps = defaultProps;

export default Reviews;
